import configs from "@/../app.config.json";
let TITTLE = ""
switch (process.env.NODE_ENV) {
    case 'development':
        TITTLE = configs.otimizacaoHomolog.titulo;
        break;
    case 'preproduction':
        TITTLE = configs.otimizacaoPreProd.titulo;
        break;
    case 'production': 
    default     :
        TITTLE = configs.otimizacaoProd.titulo;
        break;
}
let prefix = "/";

const linksAntigosApp = [
    "hubperfil/pedidos",
    "tickets/:idapresentacao",
    "hubperfil",
    "hubperfil/financeiro",
    "sersocioendereco",
];
const linksOlds = [];

linksAntigosApp.forEach((item, index) => {
    linksOlds.push({
        path: prefix + item,
        name: "Update" + index,
        props: true,
        params: true,
        redirect: prefix + "update",
    });
});

export default [
    {
        path: "*",
        name: "Error",
        component: () =>
            import(/* webpackChunkName: "error" */ "@/views/Error.vue"),
        meta: { title: TITTLE + "Error 404", requiresAuth: false },
    },
    {
        path: prefix + "noconnection",
        name: "SemConexao",
        component: () =>
            import(
                /* webpackChunkName: "semconexao" */ "@/views/Sem-conexao.vue"
            ),
        meta: { title: TITTLE + "No Connection", requiresAuth: false },
    },
    {
        path: prefix + "politics/privacity",
        name: "Politics",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "login" */ "@/views/politicas/Politics.vue"
            ),
        meta: {
            title: TITTLE + "Privacy politics",
            requiresAuth: false,
        },
    },
    {
        path: prefix + "politics/cookies",
        name: "PoliticsCookies",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "login" */ "@/views/politicas/Politics.vue"
            ),
        meta: {
            title: TITTLE + "Privacy Policy",
            requiresAuth: false,
        },
    },
    {
        path: prefix + "/",
        name: "Login",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "login" */ "@/views/onboarding/Login.vue"
            ),
        meta: { title: TITTLE + "Login", requiresAuth: false },
    },
    {
        path: prefix + "forgotpassword",
        name: "Esquecisenha",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "esqueciSenha" */ "@/views/onboarding/Forgot-password.vue"
            ),
        meta: { title: TITTLE + "Forgot Password", requiresAuth: false },
    },
    {
        path: prefix + "newpassword",
        name: "NovaSenha",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "esqueciSenha" */ "@/views/Nova-senha.vue"
            ),
        meta: { title: TITTLE + "New Password", requiresAuth: false },
    },
    {
        path: prefix + "registration/:type",
        name: "Cadastro",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "cadastro" */ "@/views/onboarding/Signin.vue"
            ),
        meta: { title: TITTLE + "Registration", requiresAuth: false },
    },
    {
        path: prefix + "foreigner",
        name: "CadastroEstrangeiro",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "cadastro" */ "@/views/onboarding/Foreigner.vue"
            ),
        meta: { title: TITTLE + "Registration Foreigner", requiresAuth: false },
    },
    {
        path: prefix + "fanhub",
        name: "Hub",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "hub" */ "@/views/Hub.vue"),
        meta: { title: TITTLE + "Fan Hub", requiresAuth: true },
    },
    {
        path: prefix + "hubprofile",
        name: "Perfil",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "perfil" */ "@/views/profile/Home.vue"),
        meta: { title: TITTLE + "Hub Profile", requiresAuth: true },
    },
    {
        path: prefix + "hubprofile/data",
        name: "HubDados",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "perfil/dados" */ "@/views/profile/Dados.vue"
            ),
        meta: { title: TITTLE + "Hub Data", requiresAuth: true },
    },
    {
        path: prefix + "hubprofile/address",
        name: "HubEndereco",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "perfil/endereco" */ "@/views/profile/Address.vue"
            ),
        meta: { title: TITTLE + "Hub Address", requiresAuth: true },
    },
    {
        path: prefix + "hubprofile/resquest",
        name: "HubPedidos",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "perfil/address" */ "@/views/profile/Pedidos-abertos.vue"
            ),
        meta: { title: TITTLE + "Hub Resquests", requiresAuth: true },
    },
    {
        path: prefix + "perfil/finishedresquest",
        name: "HubPedidosFinalizados",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "perfil/address" */ "@/views/profile/Pedidos-finalizados.vue"
            ),
        meta: { title: TITTLE + "Hub Finished Resquests", requiresAuth: true },
    },
    {
        path: prefix + "games",
        name: "Jogos",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "perfil/jogos" */ "@/views/Matchs.vue"),
        meta: { title: TITTLE + "Hub Games", requiresAuth: true },
    },
    {
        path: prefix + "jogosquejafui",
        name: "jogosjafui",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "jogosjafui" */ "@/views/Past-matchs.vue"
            ),
        meta: { title: TITTLE + "Jogos que ja Fui", requiresAuth: true },
    },
    {
        path: prefix + "hubprofile/financial",
        name: "HubFinanceiro",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "perfil/financeiro" */ "@/views/profile/Financeiro-prox.vue"
            ),
        meta: { title: TITTLE + "Hub Financial", requiresAuth: true },
    },
    {
        path: prefix + "perfil/financialpaid",
        name: "HubFinanceiroPago",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "perfil/financeiropago" */ "@/views/profile/Financeiro-pago.vue"
            ),
        meta: { title: TITTLE + "Hub Financial Paid", requiresAuth: true },
    },
    {
        path: prefix + "perfil/financialcard",
        name: "HubFinanceiroCartao",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "perfil/financeirocartao" */ "@/views/profile/Financeiro-cartao.vue"
            ),
        meta: { title: TITTLE + "Hub Financial Card", requiresAuth: true },
    },
    {
        path: prefix + "plans",
        name: "Planos",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "entrar" */ "@/views/Plans.vue"),
        meta: { title: TITTLE + "plans", requiresAuth: true },
        children: [
            {
                path: "p/:plano",
                name: "PlanosSegmentado",
            },
        ],
    },
    {
        path: prefix + "planeschair",
        name: "PlanosCadeira",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "entrar" */ "@/views/Planos.vue"),
        meta: { title: TITTLE + "plans chair", requiresAuth: true },
    },
    // {
    //     path: prefix + 'senddocuments',
    //     name: 'EnviarDoc',
    //     props: true,
    //     params: true,
    //     component: () => import(/* webpackChunkName: "enviardocumentos" */ '@/views/Sersocio.vue'),
    //     meta: { title: TITTLE + 'Send Documents', requiresAuth: true }
    // },
    {
        path: prefix + 'parthneracademia',
        name: 'SerSocioAcademia',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "sparthneracademia" */ '@/views/checkout-member/Success-Academia.vue'),
        meta: { title: TITTLE + 'Parthner Academia', requiresAuth: true }
    },
    {
        path: prefix + "parthneradress",
        name: "SerSocioEndereco",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "sersocioendereco" */ "@/views/checkout-member/Address.vue"
            ),
        meta: { title: TITTLE + "Parthner Adress", requiresAuth: true },
    },
    {
        path: prefix + "parthnerpayment",
        name: "SerSocioPagamento",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "sersociopagamento" */ "@/views/checkout-member/Payment.vue"
            ),
        meta: { title: TITTLE + "Parthner Payment", requiresAuth: true },
    },
    {
        path: prefix + "parthneractivation",
        name: "SerSocioAtivacao",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "sersocioativacao" */ "@/views/checkout-member/Activation.vue"
            ),
        meta: { title: TITTLE + "Parthner Activation", requiresAuth: true },
    },
    {
        path: prefix + "parthnercheckout",
        name: "SerSocioCheckout",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "sersociocheckout" */ "@/views/Sersocio.vue"
            ),
        meta: { title: TITTLE + "Parthner Checkou", requiresAuth: true },
    },
    {
        path: prefix + "tickets/:pagina",
        name: "PaginaTickets",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "tickets" */ "@/views/Match.vue"),
        meta: { title: TITTLE + "Tickets", requiresAuth: true },
    },
    {
        path: prefix + "ticketschair/:pagina",
        name: "TicketsCadeira",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "ticketscadeira/:pagina" */ "@/views/Comprar-tickets.vue"
            ),
        meta: { title: TITTLE + "Tickets chair", requiresAuth: true },
    },
    {
        path: prefix + "ticketsinformation/:pagina",
        name: "TicketsInformacao",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "ticketsinformacao/:pagina" */ "@/views/Comprar-tickets.vue"
            ),
        meta: { title: TITTLE + "Tickets Information", requiresAuth: true },
    },
    {
        path: prefix + "ticketscheckout/:pagina",
        name: "TicketsCheckout",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "ticketscheckout/:pagina" */ "@/views/Comprar-tickets.vue"
            ),
        meta: { title: TITTLE + "Checkout", requiresAuth: true },
    },

    {
        path: prefix + "cart/:pagina",
        name: "Cart",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "Carrinho" */ "@/views/cart/Cart.vue"),
        meta: { title: TITTLE + "Carrinho", requiresAuth: true },
    },
    {
        path: prefix + "cart/success/:pagina",
        name: "CartSuccess",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "Carrinho - Sucesso" */ "@/views/cart/Success.vue"
            ),
        meta: { title: TITTLE + "Cart - Success", requiresAuth: true },
    },

    {
        path: prefix + "chairrent",
        name: "LocarCadeira",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "locarcadeira" */ "@/views/checkout-seats/Seat.vue"
            ),
        meta: { title: TITTLE + "Rent Chair", requiresAuth: true },
    },
    {
        path: prefix + "rentchairinformation",
        name: "LocarCadeiraInformacao",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "locarcadeirainformacao" */ "@/views/checkout-seats/Confirmation.vue"
            ),
        meta: { title: TITTLE + "Rent Chair Information", requiresAuth: true },
    },
    {
        path: prefix + "rentchairpayment",
        name: "LocarCadeiraPagamento",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "locarcadeirapagamento" */ "@/views/checkout-seats/Payment.vue"
            ),
        meta: { title: TITTLE + "Rent Chair Payment", requiresAuth: true },
    },
    {
        path: prefix + "rentchairactivation",
        name: "LocarCadeiraAtivacao",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "locarcadeiraativacao" */ "@/views/Locacao-cadeira.vue"
            ),
        meta: { title: TITTLE + "Rent Chair Activation", requiresAuth: true },
    },
    {
        path: prefix + "rentsuccess",
        name: "PagarLocacaoSucesso",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "rentcheckout" */ "@/views/checkout-seats/Success-seats.vue"
            ),
        meta: { title: TITTLE + "Rent Success", requiresAuth: true },
    },
    {
        path: prefix + "welcome",
        name: "BoasVindas",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "boasvindas" */ "@/views/boas-vindas.vue"
            ),
        meta: { title: TITTLE + "Welcome", requiresAuth: true },
    },
    {
        path: prefix + "webmail/view/:idmail",
        name: "Webmail",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "Webmail" */ "@/views/ViewEmails.vue"),
        meta: { title: TITTLE + "Webmail", requiresAuth: false },
    },
    {
        path: prefix + "live",
        name: "Live",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "Carrinho" */ "@/views/Live.vue"),
        meta: { title: TITTLE + "Ao vivo", requiresAuth: true },
    },
    {
        path: prefix + "ajuda",
        name: "Help",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "Carrinho" */ "@/views/help/Help.vue"),
        meta: { title: TITTLE + "Ajuda", requiresAuth: true },
    },
    {
        path: prefix + "design-system",
        name: "DesignSystem",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "DesignSystem" */ "@/views/DesignSystem.vue"
            ),
        meta: { title: TITTLE + "Design System", requiresAuth: true },
    },
    {
        path: prefix + "app",
        name: "App",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "Webmail" */ "@/views/App.vue"),
        meta: {
            title: TITTLE + "Aplicativo Mundo Colorado",
            requiresAuth: false,
        },
    },
    {
        path: prefix + "landpage/:pagina",
        name: "Landpage",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "Webmail" */ "@/views/Landingpage.vue"),
        meta: { title: TITTLE + "Landpage", requiresAuth: true },
    },
    {
        path: prefix + "noite-gigante",
        name: "NoiteGigante",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "Webmail" */ "@/views/Noite-gigante.vue"
            ),
        meta: { title: TITTLE + "Landpage", requiresAuth: true },
    },
    {
        path: prefix + "noite-gigante-ingressos",
        name: "NoiteGiganteIngressos",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "Webmail" */ "@/views/Noite-gigante-ingressos.vue"
            ),
        meta: { title: TITTLE + "Landpage", requiresAuth: true },
    },
    {
        path: prefix + "voucher",
        name: "Voucher",
        props: true,
        params: true,
        component: () =>
            import(/* webpackChunkName: "Webmail" */ "@/views/Voucher.vue"),
        meta: { title: TITTLE + "Voucher", requiresAuth: true },
    },

    // Institucionais
    {
        path: prefix + "beira-rio",
        name: "BeiraRio",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "BeiraRio" */ "@/views/institucionais/Beira-rio.vue"
            ),
        meta: { title: TITTLE + "Beira-Rio", requiresAuth: false },
    },

    ...linksOlds,
];
